// extracted by mini-css-extract-plugin
module.exports = {"button":"ComboCartIndicatorBaga-button-07f2"};